import { render } from "./PageCase.vue?vue&type=template&id=51f6456b&scoped=true"
import script from "./PageCase.vue?vue&type=script&lang=js"
export * from "./PageCase.vue?vue&type=script&lang=js"

import "./PageCase.vue?vue&type=style&index=0&id=51f6456b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f6456b"]])

export default __exports__